/**
 * 通知中心仓储 · 真实后端实现（platform.notification）
 * ------------------------------------------------------------
 * 通知是任务主页信息的整体通知：新事项指派 / 材料更新需重看 / 决定进展，
 * 由服务端在业务事务内幂等推送；已读态服务端持久（read_at），换浏览器不丢。
 * 无 mock 回落：服务不可用时错误原样抛给 UI 展示，不伪造空列表。
 */
import { httpNotifyImpl } from './http-backend'
import type { NotifItem } from '../mock/notify'

/** ISO 时间 → 面板展示格式 MM-DD HH:mm */
function fmtTime(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso || ''
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
}

export const notifyRepo = {
  async list(): Promise<NotifItem[]> {
    const rows = await httpNotifyImpl.list()
    return rows.map(r => ({ ...r, time: fmtTime(r.time) }))
  },
  markRead: (id: string): Promise<void> => httpNotifyImpl.markRead(id),
  markAllRead: (): Promise<void> => httpNotifyImpl.markAllRead()
}
